import Image from 'next/image'
import Decoration from '../../../public/static/banner/president/product/spring-sale-decoration.svg'
import TextHoliday from '../../../public/static/banner/president/product/spring-sale.svg'
import IconChecked from '../../../public/static/banner/black-friday/product/check-purple.svg'
import { useGetBlackFriday } from '../../../hooks/marketing/useGetBlackFriday'

type Props = {
  showDecoration?: boolean
}
export default function BlackFridayCardV2({ showDecoration = true }: Props) {
  const { data } = useGetBlackFriday()

  if (data?.countDown.values.seconds && data?.countDown.values.seconds <= 0) {
    return null
  }

  return (
    <div className={'relative'}>
      <div
        className={
          'relative w-full h-full rounded-[6px] border border-[#2C1149] overflow-hidden '
        }
      >
        <div
          className={
            'flex flex-row gap-1 items-center h-28 w-full bg-[#150922] text-body-medium text-white rounded-md pr-0 sm:pr-5 pointer-events-none'
          }
        >
          {/* <div className={'top-0 bottom-0 right-0 w-[78%] absolute z-20'}>
           <Image
              src={Background}
              alt={'Background'}
              className={'rounded-md '}
              fill={true}
              priority={true}
            />
          </div> */}

          <div
            className={
              'relative z-10 h-28 w-[58%] lg:w-[45%] xl:w-[35%] shrink-0'
            }
          >
            <Image
              src={TextHoliday}
              className={'object-cover'}
              alt={'New season'}
              fill={true}
            />
          </div>

          <div className={'flex flex-col gap-0'}>
            <p className={'text-2xs-medium text-[#21FF9E] z-20 font-bold'}>
              TIME’S TICKING!
            </p>

            <div className={'flex flex-row gap-2 items-start z-20'}>
              <div className={'relative h-4 w-4 shrink-0 lg:flex hidden mt-1'}>
                <Image src={IconChecked} alt={'checked icon'} fill={true} />
              </div>

              <div
                className={
                  'max-w-full text-secondary-medium lg:text-body-medium text-white'
                }
              >
                Use <span className={'text-[#C3FF00]'}>SPRING15</span> for{' '}
                <span className={'text-[#C85BFF]'}>15% OFF</span> your next 3{' '}
                <br />
                orders—only while the Spring Sale lasts.
              </div>
            </div>

            {/*<div*/}
            {/*  className={'flex flex-row gap-2 items-start z-20 lg:ml-5 ml-2'}*/}
            {/*>*/}
            {/*  <div className={'relative h-4 w-4 shrink-0 lg:flex hidden mt-1'}>*/}
            {/*    <Image src={IconChecked} alt={'checked icon'} fill={true} />*/}
            {/*  </div>*/}

            {/*  <div*/}
            {/*    className={*/}
            {/*      'max-w-full text-secondary-medium md:text-body-medium'*/}
            {/*    }*/}
            {/*  >*/}
            {/*    Enjoy <span className={'text-[#6BEDFF]'}>5% off </span>*/}
            {/*    all packages!*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          {/* <button
            className={
              'btn border-none bg-[#8F15CD] pointer-events-auto hover:bg-[#8F15CD]  text-white rounded-lg z-20 font-oswald font-semibold  px-5 py-3 mx-3 hidden xl:flex transition-opacity duration-300 hover:opacity-80'
            }
          >
            BUY NOW!
          </button> */}
        </div>
      </div>
      {showDecoration && (
        <div
          className={'lg:flex hidden z-30'}
          style={{
            position: 'absolute',
            right: '-12px',
            top: '-12px',
            width: '50px',
            height: '50px',
          }}
        >
          <Image src={Decoration} alt={'Badge Icon'} fill={true} />
        </div>
      )}
    </div>
  )
}
